<template>
  <div class="search-form px-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset.prevent="onReset"
    >
        <div class="container-fluid">
            <div class="row nopads">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mb-3">
                    <div class="form-group nopads">
                        <label for="start" class="span-title">
                            {{ $t('orders.create_time') }} - {{ $t('trip_list.road_sec_from') }}
                        </label>
                        <input
                            id="start"
                            v-model="createdFromDate"
                            type="date"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mb-3">
                    <div class="form-group nopads">
                        <label for="end" class="span-title">
                            {{ $t('orders.create_time') }} - {{ $t('trip_list.road_sec_to') }}
                        </label>
                        <input
                            id="end"
                            v-model="createdToDate"
                            type="date"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mb-3">
                    <div class="form-group nopads">
                        <label for="closedStart" class="span-title">
                            {{ $t('observations.closed_time') }} - {{ $t('trip_list.road_sec_from') }}
                        </label>
                        <input
                            id="closedStart"
                            v-model="closedFromDate"
                            type="date"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mb-3">
                    <div class="form-group nopads">
                        <label for="closedEnd" class="span-title">
                            {{ $t('observations.closed_time') }} - {{ $t('trip_list.road_sec_to') }}
                        </label>
                        <input
                            id="closedEnd"
                            v-model="closedToDate"
                            type="date"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row nopads px-2">
            <div
                class="col-sm-6 mt-2"
            >
                <open-contract-filter
                    ref="contractFilter"
                    :from="createdFromDate"
                    :to="createdToDate"
                    :show-only-my-contracts-option="true"
                    :show-title="true"
                    :show-company="false"
                    @contract-selected="setContract"
                />
            </div>
            <div class="col-sm-6 pt-1" style="margin-top: -1px">
                <contract-order-multiselect
                    ref="orderFilter"
                    :contract-ids="contract ?  [contract.id] : []"
                    :single-mode="true"
                    @orders-selected="setOrder"
                />
            </div>

        </div>

      <div class="row nopads px-2">
        <div class="col-sm-4">
          <div
            class="nopads"
            label-for="assignedTo"
          >
            <span class="span-title">{{ $t('work_assignment.assigned_to') }}</span>
            <select
              id="assignedTo"
              v-model="assignedTo"
              class="form-select form-select-sm"
              :disabled="!users || !users.length || executor"
            >
                <option :value="null">
                  {{ $t('trip_list.select_user') }}
                </option>
              <option
                v-for="option in users"
                :key="option.id"
                size="sm"
                :value="option.id"
              >
                {{ option.last_name + ', ' + option.first_name }}
              </option>
            </select>
          </div>
        </div>
          <!-- Contractor -->
        <div class="col-sm-4">
              <span class="span-title">{{ $t('work_assignment.assignee_company') }}</span>
              <select
                  id="customer"
                  v-model="executor"
                  class="form-select form-select-sm mb-3"
                  :disabled="assignedTo || !companyOptions || companyOptions.length < 1"
              >
                  <option :value="null">
                      {{ $t('users.select_company') }}
                  </option>
                  <option v-for="c in companyOptions" :key="c.value" :value="c.value">
                      {{ c.name }}
                  </option>
              </select>
        </div>
        <div class="col-sm-4">
          <div
            class="nopads"
            label-for="createdBy"
          >
            <span class="span-title">{{ $t('work_assignment.created_by') }}</span>
            <select
              id="assignedTo"
              v-model="createdBy"
              class="form-select form-select-sm"
              :disabled="!assigners||!assigners.length"
            >
                <option :value="null">
                  {{ $t('trip_list.select_user') }}
                </option>
              <option
                v-for="option in assigners"
                :key="option.id"
                size="sm"
                :value="option.id"
              >
                  {{ option.last_name + ', ' + option.first_name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row nopads px-2">
          <div v-if="isObserver" class="col-sm-6">
              <span class="span-title">{{ $t('orders.status') }}</span>
              <div class="d-flex align-items-center">
                  <multiselect
                      class="flex-grow-1"
                      v-model="statuses"
                      :options="getStatus()"
                      :custom-label="value => getStatusString(value.status)"
                      :multiple="true"
                      :close-on-select="false"
                      label="key"
                      track-by="status"
                      :searchable="true"
                      :internal-search="true"
                      :selected-label="$t('common.selected')"
                      :select-label="$t('common.select')"
                      :deselect-label="$t('common.remove_selection')"
                      :placeholder="$t('orders.select_status')"
                  >
                      <template #singleLabel="props">
                            <span class="option__desc">
                              <span class="option__title">{{ props.option.key }}</span>
                            </span>
                      </template>

                      <template #option="props">
                          <div class="option__desc">
                              <span class="option__title multiselect_detail_block">
                                {{ props.option.key }}
                              </span>
                          </div>
                      </template>

                      <template #noResult>
                          <span>{{ $t('common.not_found') }}</span>
                      </template>

                      <template #noOptions>
                          <span>{{ $t('common.no_results') }}</span>
                      </template>
                  </multiselect>

                  <!-- BUTTON -->
                  <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm mx-1"
                      @click.stop="resetStatus"
                  >
                      <font-awesome-icon icon="trash"/>
                  </button>

              </div>
          </div>
          <div class="col-sm-3">
              <span class="span-title">{{ $t('observation_list.archived') }}</span>
              <select
                  id="archived"
                  v-model="archived"
                  class="form-select form-select-sm no-margin"
              >
                  <option
                      v-for="option in archivedOptions"
                      :key="option.value"
                      :value="option.value"
                  >
                      {{ option.text }}
                  </option>
              </select>
         </div>
        <div class="col-sm-3">
            <span class="span-title">{{ $t('common.id') }}</span>
            <input
                id="id"
                v-model="id"
                class="form-control form-control-sm"
                type="number"
            />
        </div>
      </div>

      <div class="row nopads px-2">
          <div class="col-sm-6 mt-3">
              <button type="button" class="btn btn-sm btn-outline-info form-button"
                      :class="{'primary' : mapSelectedArea, 'info' : !mapSelectedArea}"
                      style="margin-top: 1px" @click="openModalMap">
                  {{ $t('trip_list.select_area_map') }}
              </button>
              <span v-if="mapDrawnAreas" class="pl-2 hint-text">{{ $t('trip_list.area_selected') }}</span>
          </div>
      </div>

      <div class="col-sm-12 mt-2 d-flex justify-content-end">
          <button type="reset" class="btn btn-sm btn-danger form-button">
              {{ $t('ins_report.clear') }}
          </button>
        <button type="submit" class="btn btn-sm btn-primary form-button">
          {{ $t('ins_report.search') }}
        </button>
      </div>
    </form>

    <!--select area on map modal-->
    <base-modal v-if="showMapModal" size="lg" hide-header hide-footer @close="closeModalMap">
        <div class="col-12" @click.stop="">
            <div class="coordinate-map" style="height:80vh; position: relative">
                <map-container ref="map" :find-user="true" :is-editing="isEditing" :center="mapCenter"
                              @onMapChanged="mapReady" @on-zoom-level-change="onZoomLevelChange"
                              @onMapClicked="mapClicked" :menu-enabled="false" />
            </div>
            <div class="col-sm-12 text-end">
                <button type="button" @click.stop="clearPolygon" class="btn btn-sm btn-danger form-button">
                    {{ $t('ins_report.clear') }}
                </button>
                <button type="button" class="btn btn-sm btn-primary form-button" @click.stop="backFromModal">
                    {{ $t('common.back') }}
                </button>
                <button type="button" class="btn btn-sm btn-success form-button" @click.stop="closeModalMap">
                    {{ $t('common.save') }}
                </button>
            </div>
        </div>
    </base-modal>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import CompanyFilter from '../company/CompanyFilter'
import {workAssignmentHelper} from '../mixins/WorkAssignmentMixin'
import OpenContractFilter from "../contract/OpenContractFilter";
import { mapHelper } from "@/components/mixins/MapMixin";
import MapContainer from "@/components/map/MapContainer.vue";
import BaseModal from "@/components/BaseModal.vue";
import Multiselect from 'vue-multiselect';
import ContractOrderMultiselect from "../order/ContractOrderMultiselect.vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'WorkAssignmentSearch',
    components: {
        FontAwesomeIcon,
        ContractOrderMultiselect,
        CompanyFilter, OpenContractFilter, MapContainer, BaseModal, Multiselect},
    mixins: [restApi, timeUtils, workAssignmentHelper, mapHelper],
    props: {
        isObserver: Boolean,
        user: null
    },
    data: function () {
        return {
            users: [],
            assigners: [],
            companyOptions: [],
            executor: null,
            order: null,
            contract: null,
            assignedTo: null,
            statuses: null,
            createdBy: null,
            createdFromDate: null,
            createdToDate: null,
            closedFromDate: null,
            closedToDate: null,
            id: null,
            mapCenter: null,
            mapDrawnAreas: null,
            mapSelectedArea: false,
            showMapModal: false,
            isEditing: false,
            newPolygonId: -1,
            polygonDrawing: false,
            archived: 2
        }
    },
    computed: {
        statusInit() {
            return [
                {key: this.$t('work_assignment.open'), status: this.OPEN},
                {key: this.$t('work_assignment.assigned'), status: this.ASSIGNED},
                {key: this.$t('work_assignment.in_progress'), status: this.IN_PROGRESS}
            ]
        },
        companyPlaceholder() {
            return this.$t('users.select_company')
        },
        archivedOptions() {
            return [
                {value: null, text: this.$t('observations.search_all')},
                {value: 1, text: this.$t('observation_list.archived')},
                {value: 2, text: this.$t('observation_list.not_archived')},
            ]
        },

    },
    watch: {
        company: function (value) {
            if (value) {
                this.fetchUsers()
            } else {
                this.users = []
            }
        },
        assignedTo(val) {
            if (val) {
                this.executor = null
            }
        },
        executor(val) {
            if (val) {
                this.assignedTo = null
            }
        },
        contract() {
            this.fetchUsers()
            this.fetchAssigners()
        },
        createdFromDate() {
            if (this.contract) {
                this.fetchUsers()
                this.fetchAssigners()
            }
        },
        createdToDate() {
            if (this.contract) {
                this.fetchUsers()
                this.fetchAssigners()
            }
        },
        closedFromDate() {
            if (this.contract) {
                this.fetchUsers()
                this.fetchAssigners()
            }
        },
        closedToDate() {
            if (this.contract) {
                this.fetchUsers()
                this.fetchAssigners()
            }
        }
    },
    mounted: function () {
        this.statuses = this.statusInit
        if (this.isObserver) {
            this.fetchUsers()
            this.fetchAssigners()
        }
        if (!this.isObserver && this.user) {
            this.users.push(this.user)
        }

        this.createdFromDate = this.getDateAsString(this.getMonthStartAsDate())
        this.enablePolygonDrawing()
    },
    methods: {
        setOrder(order) {
            this.order = order
        },

        resetStatus() {
            this.statuses = null
        },

        fetchUsers: function () {
            this.loading = true
            this.users = []
            if (this.contract) {
                let params = {}
                params.contract = this.contract.id
                if (this.createdFromDate !== null && this.createdFromDate.trim()) {
                    params.created_from = this.localTimeToUtcTime(this.createdFromDate).toISOString()
                }
                if (this.createdToDate !== null && this.createdToDate.trim()) {
                    params.created_to = this.getEndOfTheDay(this.createdToDate).toISOString()
                }
                if (this.closedFromDate !== null && this.closedFromDate.trim()) {
                    params.closed_from = this.localTimeToUtcTime(this.closedFromDate).toISOString()
                }
                if (this.closedToDate !== null && this.closedToDate.trim()) {
                    params.closed_to = this.getEndOfTheDay(this.closedToDate).toISOString()
                }
                this.restFetchParams(this.workAssignmentResponsibleUrl, params, this.handleUsers)
            } else {
                this.restFetchParams(this.userUrl, {company: this.executor}, this.handleUsers)
            }
        },
        handleUsers: function (response) {
            this.users = response.data
            this.loading = false
        },

        fetchAssigners: function () {
            this.loading = true
            this.assigners = []
            if (this.contract) {
                let params = {}
                params.contract = this.contract.id
                if (this.createdFromDate !== null && this.createdFromDate.trim()) {
                    params.created_from = this.localTimeToUtcTime(this.createdFromDate).toISOString()
                }
                if (this.createdToDate !== null && this.createdToDate.trim()) {
                    params.created_to = this.getEndOfTheDay(this.createdToDate).toISOString()
                }
                if (this.closedFromDate !== null && this.closedFromDate.trim()) {
                    params.closed_from = this.localTimeToUtcTime(this.closedFromDate).toISOString()
                }
                if (this.closedToDate !== null && this.closedToDate.trim()) {
                    params.closed_to = this.getEndOfTheDay(this.closedToDate).toISOString()
                }
                this.restFetchParams(this.workAssignmentAssignerUrl, params, this.handleAssigners)
            } else {
                this.restFetchParams(this.userUrl, {company: this.executor}, this.handleAssigners)
            }
        },
        handleAssigners: function (response) {
            this.assigners = response.data
            this.loading = false
        },

        getContractCompanies: function () {
            this.companyOptions = []
            this.companyPlaceholder = this.$t('trip_list.search_select_contract_first')
            if (this.contract) {
                this.restFetchParams(this.contractCompanyUrl, {contract: this.contract.id}, this.handleContractCompanies)
            }
        },
        handleContractCompanies: function (response) {
            if (response && response.data) {
                this.companyPlaceholder = this.$t('')
                response.data.forEach(company => {
                    this.companyOptions.push({name: company.name, value: company.id})
                })
                this.companyPlaceholder = this.$t('users.select_company')
            }
            this.loading = false
        },
        setContract: function (contract) {
            this.contract = contract ? contract : null
            this.getContractCompanies()
        },
        onSubmit: function () {
            var params = {}
            if (this.executor) {
                params.executor = this.executor
            }
            if (this.contract) {
                params.contract = this.contract.id
                params.contractor = this.contract.contractor.id
                params.customer = this.contract.customer.id
            }
            if (this.id) {
                params.id = this.id
            }
            if (this.order) {
                params.order = this.order.id
            }
            if (this.assignedTo) {
                params.assigned_to = this.assignedTo
            }
            if (this.createdBy) {
                params.created_by = this.createdBy
            }
            if (this.createdFromDate !== null && this.createdFromDate.trim()) {
                params.created_from = this.localTimeToUtcTime(this.createdFromDate).toISOString()
            }
            if (this.createdToDate !== null && this.createdToDate.trim()) {
                params.created_to = this.getEndOfTheDay(this.createdToDate).toISOString()
            }
            if (this.statuses && this.statuses.length > 0) {
                let statusArray = []
                this.statuses.forEach(item => {
                    statusArray.push(item.status)
                })
                params.statuses = statusArray
            }
            if (this.closedFromDate !== null && this.closedFromDate.trim()) {
                params.closed_from = this.localTimeToUtcTime(this.closedFromDate).toISOString()
            }
            if (this.closedToDate !== null && this.closedToDate.trim()) {
                params.closed_to = this.getEndOfTheDay(this.closedToDate).toISOString()
            }
            params.archived = this.archived
            if (this.newPolygonId > 0) {
                const polygonObj = this.mapDrawnAreas;
                if (polygonObj !== null && polygonObj.length >= 4) {
                    params.polygon_search = "POLYGON((" + polygonObj.map(ob => ob.join(' ')) + "))";
                }
            }
            this.$emit('search', params)
        },
        onReset: function () {
            this.statuses = null
            this.executor = null
            this.contract = null
            this.assignedTo = null
            this.createdBy = null
            this.order = null
            this.createdToDate = null
            this.closedFromDate = null
            this.closedToDate = null
            this.$refs.contractFilter.reset()
            this.$refs.orderFilter.reset()
            this.mapDrawnAreas = null
            this.mapSelectedArea = false
        },
        openModalMap() {
            if (this.getMapSettingsIn && this.getMapSettingsIn(['center'])) {
                this.mapCenter = this.getMapSettingsIn(['center'])
            } else if (this.user && this.user.company.location) {
                this.mapCenter = {
                    lon: this.user.company.location.x,
                    lat: this.user.company.location.y,
                }
            }
            this.showMapModal = true
        },
        closeModalMap() {
            this.mapDrawnAreas = this.getPolygon()
            this.showMapModal = false
        },
        backFromModal() {
            this.showMapModal = false
            if (this.mapDrawnAreas === null) {
                this.newPolygonId = -1
            }
        },
        mapReady() {
            this.redrawArea()
        },
        onZoomLevelChange(data) {
            this.$store.commit('storeMapZoomLevel', data)
        },
        mapClicked(coord) {
            if (this.polygonDrawing && !this.isEditing) {
                this.addPointToPolygon(coord)
            }
        },
        clearPolygon() {
            if (this.$refs.map) {
                this.$refs.map.getMap().removePolygon(this.newPolygonId, 'OTHER')
                this.enablePolygonDrawing()
            }
        },
        enablePolygonDrawing() {
            this.newPolygonId = -1
            this.polygonDrawing = true
        },
        addPointToPolygon(point) {
            if (this.$refs.map) {
                if (this.newPolygonId < 0) {
                    this.newPolygonId = Date.now()
                    this.$refs.map.getMap().newPolygon(this.newPolygonId, point.lat, point.lng, 'OTHER')
                } else {
                    this.$refs.map.getMap().addPointToPolygon(this.newPolygonId, point.lat, point.lng, 'OTHER')
                }
            }
        },
        getPolygon() {
            if (this.newPolygonId === -1 || !this.$refs.map) {
                return null
            }
            let original = this.$refs.map.getMap().getPolygonBoundaries(this.newPolygonId, 'OTHER')
            let result = original[0].map(item => [item['lng'], item['lat']])
            result.push([original[0][0].lng, original[0][0].lat])
            return result
        },
        redrawArea() {
            this.$nextTick(() => {
                this.drawAreas(this.mapDrawnAreas)
            })
        },
        drawAreas(areas) {
            if (areas && areas.length > 0) {
                if (this.newPolygonId !== -1) {
                    this.newPolygonId = -1
                    areas.forEach(area => {
                        const poly = { lng: area[0], lat: area[1] }
                        this.addPointToPolygon(poly)
                    })
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
